import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Flex,
} from '@chakra-ui/react';
import { getIn } from 'formik';
import * as _ from 'lodash';
import React, { useState } from 'react';
import { flatMap, keys, map, pipe } from 'remeda';

import {
  CreditAgreement,
  Organization,
  Util,
} from '@finley-technologies/finley-types';

import { WipConfig } from '../../types';
import { Select } from 'packages/common-frontend/components/Select';

const convertToCapitalProviderEntity = (
  capitalProvider: Organization.BaseOrganization,
) => ({
  _isWrittenIn_: true,
  entity: {
    id: capitalProvider.id,
    name: capitalProvider.name,
    slug: capitalProvider.slug,
  },
});

type AddClassCapitalProviderModalProps = {
  basePropertyKey: string;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  wipConfig: WipConfig;
  classes: CreditAgreement.DomainEntity.ClassDetailsWithEntities[];
};
export const AddClassCapitalProviderModal = ({
  basePropertyKey,
  isOpen,
  setIsOpen,
  wipConfig: { formProps, capitalProvidersMap },
  classes,
}: AddClassCapitalProviderModalProps) => {
  const possibleKeys = keys(capitalProvidersMap);

  const currentKeys = pipe(
    classes,
    flatMap((classDetails) =>
      map(classDetails.capitalProviders, (cp) => cp.entity.id),
    ),
  );

  const selectionKeys = _.difference(possibleKeys, currentKeys);
  const selectionOptions = map(selectionKeys, (key) => {
    const entity = capitalProvidersMap[key];
    return { label: entity.name, value: key };
  });

  const [selectedKey, setSelectedKey] = useState<Util.Maybe<string>>(undefined);

  const createProperty = ({
    capitalProvider,
  }: {
    capitalProvider: Organization.BaseOrganization;
  }) => {
    const capitalProviderEntity = convertToCapitalProviderEntity(
      capitalProvider,
    );
    const propertySection = getIn(formProps.values, basePropertyKey);

    const updatedPropertySetion = [...propertySection, capitalProviderEntity];
    formProps.setFieldValue(basePropertyKey, updatedPropertySetion);
  };

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} size="3xl">
      <ModalOverlay />
      <ModalContent padding="20px">
        <ModalHeader>Add Class Details</ModalHeader>
        <ModalCloseButton />
        <ModalBody width="100%">
          {
            // TODO - render props for edit
          }
          <Select
            value={selectedKey}
            onChange={(propertyKey: Util.Maybe<string>) => {
              setSelectedKey(propertyKey);
            }}
            options={selectionOptions}
            placeholderLabel="Select Capital Provider"
          />
          <Flex justifyContent="center" mt="8">
            <Button
              onClick={() => {
                if (selectedKey) {
                  const capitalProvider = capitalProvidersMap[selectedKey];
                  createProperty({ capitalProvider });
                }
                setSelectedKey(undefined);
                setIsOpen(false);
              }}
              aria-label="Done"
              isDisabled={_.keys(formProps.errors).length > 0}
            >
              Done
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
